// ----------------------------------------------------------------------

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

// ----------------------------------------------------------------------

const FONT_PRIMARY = 'Whitney Medium'; // Local Font

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 500,
  fontWeightMedium: 500,
  fontWeightBold: 500,
  h1: {
    fontWeight: 500,
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontWeight: 500,
    lineHeight: 64 / 48,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(24),
    fontFamily: 'Whitney Semibold',
    ...responsiveFontSizes({ sm: 26, md: 36, lg: 36 }),
  },
  h4: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '28px !important',
    fontFamily: 'Whitney Semibold',
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
   h5: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '22px',
    fontFamily: 'Whitney Semibold',
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 22 }),
  }, 
  h6: {
    fontWeight: 500,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    fontFamily: 'Whitney Semibold',
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle3: {
    fontWeight: 500,
    lineHeight: '34.32px',
    fontFamily: 'Whitney Semibold',
    letterSpacing:"0.17px",
    ...responsiveFontSizes({ sm: 16, md: 20, lg: 24 }),
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontFamily: 'Whitney',
    fontSize: pxToRem(18),
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  subtitle4: {
    fontWeight: 500,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
    fontFamily: 'Whitney',
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 500,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'capitalize',
  },
  normalText: {
    fontWeight: 500,
    lineHeight: 22 / 14,
    fontSize: pxToRem(18),
  },
  secondaryButton: {
    fontWeight: 500,
    lineHeight: 28 / 18,
    fontSize: pxToRem(20),
    fontFamily: 'Whitney Semibold',
    ...responsiveFontSizes({ sm: 18, md: 20, lg: 20 }),
  },
  shippingCardValue: {
    fontWeight: 500,
    fontSize: '28px',
    fontFamily: 'Whitney Semibold',
    ...responsiveFontSizes({ sm: 18, md: 22, lg: 28 }),
  },
   cardTitle: {
    fontWeight: 500,
    fontSize: '22px',
    fontFamily: 'Whitney Semibold',
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 22 }),
  },
  ReportsCardValue: {
    fontWeight: 500,
    fontSize: '32px',
    fontFamily: 'Whitney Semibold',
    ...responsiveFontSizes({ sm: 28, md: 30, lg: 32 }),
  },

};

export default typography;

